import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { StatusBadge } from '@/tracker/entities/status';
import { useIssueDrawer } from '@/tracker/features/issueDrawer';
import { Board, TaskBasic } from '@/tracker/types';

import { formatTime, formatTimeInStatus } from './formatTime';

import s from './BoardCard.module.scss';

type Props = {
  issue: TaskBasic;
  /** Оценка на доске: story points или время */
  estimateBy: Board['estimateBy'];
};

const BoardCard: React.FC<Props> = observer(({ issue, estimateBy }) => {
  const { issueLink } = useIssueDrawer();

  // statusChangeTime бывает null — тогда задача в статусе с момента создания
  const statusSince = DateTime.fromISO(issue.statusChangeTime ?? issue.createTime);
  const estimate =
    estimateBy === 'story_points'
      ? issue.storyPoints !== null && `${issue.storyPoints} SP`
      : formatTime(issue);

  return (
    <Link to={issueLink(issue.key)} className={s.card}>
      <span className={s.card__key}>{issue.key}</span>
      <span className={s.card__summary}>{issue.summary}</span>
      <span className={s.card__meta}>
        <StatusBadge status={issue.status} />
        <span
          className={s.card__secondary}
          title={`В статусе с ${statusSince.toFormat('dd.MM.yyyy HH:mm')}`}
        >
          {formatTimeInStatus(statusSince)}
        </span>
        {estimate && (
          <span
            className={s.card__time}
            title={estimateBy === 'story_points' ? 'Story points' : 'Затрачено / оценка'}
          >
            {estimate}
          </span>
        )}
      </span>
    </Link>
  );
});

export { BoardCard };
